import React from "react";
import {StyleSheet, Text, View, StatusBar, Image, ScrollView, Animated, TouchableOpacity} from 'react-native';
import {RFValue} from "react-native-responsive-fontsize";
import { AntDesign } from '@expo/vector-icons';
import { Entypo } from '@expo/vector-icons';
const Acording = (Props)=>{
    const fadeAnim = React.useRef(new Animated.Value(0)).current; // Initial value for opacity: 0

    const [isopen,setOpen] = React.useState(false);


    let list = Props.list;



    let bg = 'rgba(0,0,0,0.28)';

    if(Props.master == 0){
        bg = 'rgba(0,0,0,0)';
    }


    const anim = ()=>{
        if(!isopen){
            setOpen(true);
            Animated.timing(fadeAnim, {
                toValue: 999,
                duration: 500,
                useNativeDriver: false,

            }).start();
        }else{
            setOpen(false);
            Animated.timing(fadeAnim, {
                toValue: 0,
                duration: 500,
                useNativeDriver: false,

            }).start();
        }
    }




    // <Animated.View
    //     style={{
    //         justifyContent : 'center',
    //         alignItems : 'center',
    //         backgroundColor : 'red',
    //
    //         // height: 100,
    //         maxHeight: fadeAnim,
    //     }}>
    //     <Text>123</Text>
    // </Animated.View>

    return (
        <View
            style={{
            borderWidth : 1,
            padding : RFValue(5),
            borderColor : '#FFF',
            backgroundColor : bg,
        }}>
           <View style={{
               flexDirection : 'row',
               alignItems : 'center'

           }}>
               <Image
                   resizeMode={'stretch'}
                   fadeDuration={999}
                   style={{
                       width : 35,
                       height :35,
                       margin : 10,
                       borderRadius : 15,
                   }}
                   source={{uri : Props.avatar}}
               />
               <Text style={{
                   fontFamily : 'novaria',
                   flexGrow : 1,
                   textAlign : 'left',
                   color:'#FFF',
                   textShadowColor: 'rgba(0, 0, 0, 0.75)',
                   textShadowOffset: {width: -1, height: 1},
                   textShadowRadius: 3
               }}>
                   {Props.name}
               </Text>
               {list.length > 0 &&
                   <TouchableOpacity onPress={anim}>

                       {isopen ?
                           <Entypo style={{paddingHorizontal : RFValue(10)}} name="minus" size={RFValue(18)} color="#FFF" />
                           :
                           <AntDesign  style={{paddingHorizontal : RFValue(10)}} name="plus" size={RFValue(18)} color="#FFF" />
                       }
                   </TouchableOpacity>
               }

           </View>
            {list.length > 0 &&
                <Animated.View   style={{
                    maxHeight: fadeAnim,
                }}>
                    {isopen &&
                       <>
                           {list.map((item ,index) =>
                               <Acording master={0} key={index} name={item.name} list={item.list} avatar={item.avatar}></Acording>
                           )}

                       </>
                    }

                </Animated.View>
            }

        </View>
    );
}


export default Acording;
